import { BrokerSignScreenStepProps } from '../../../shared/broker/types'

import { View } from './view'

export const BrokerSignDocumentsList = (ownProps: BrokerSignScreenStepProps) => {
	return View({
		documents: ownProps.documents,
		onNextButtonClick: ownProps.onNext,
		brokerName: ownProps.uiConfig.params.brokerOrgName!,
	})
}
